var _toConsumableArray = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/kotborealis/projects/lua-trans/app/node_modules/@babel/runtime/helpers/createClass");

var antlr4 = require('antlr4');

var Lexer = require('../antlr/LuaLexer').LuaLexer;

var Parser = require('../antlr/LuaParser').LuaParser;

var Visitor = require('./Visitor');

var Globals = require('./Globals');

var Memory = require('./Memory');

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function _class() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        print_fn = _ref.print_fn;

    _classCallCheck(this, _class);

    this.mem = new Memory();
    var globals = Globals({
      print_fn: print_fn
    });
    Object.entries(globals).forEach(function (fn) {
      var _this$mem$global;

      return (_this$mem$global = _this.mem.global).set.apply(_this$mem$global, _toConsumableArray(fn));
    });
  }

  _createClass(_class, [{
    key: "compile",
    value: function compile(chunk) {
      var removeErrorListeners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var chars = new antlr4.InputStream(chunk);
      var lexer = new Lexer(chars);
      var tokens = new antlr4.CommonTokenStream(lexer);
      var parser = new Parser(tokens);
      parser.buildParseTrees = true;
      if (removeErrorListeners) parser.removeErrorListeners();
      var tree = parser.chunk();

      if (parser._syntaxErrors > 0) {
        throw new Error("Syntax errors while parsing: ".concat(parser._syntaxErrors));
      }

      return tree;
    }
  }, {
    key: "evaluate",
    value: function evaluate(chunk) {
      var tree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      try {
        if (tree === null) tree = this.compile(chunk);
        var visitor = new Visitor({
          mem: this.mem
        });
        visitor.visitChunk(tree);
      } catch (e) {
        throw e;
      }
    }
  }]);

  return _class;
}();